import { observer } from 'mobx-react-lite';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import { MeetingMessageActionType } from '../utils/MeetingMessageActionType';
import MeetingCancellationAction from './MeetingCancellationAction';

import * as React from 'react';

const styles = require('./MeetingMessageActions.scss');

export interface MeetingCancellationInfoProperties {
    item: MeetingCancellationMessageType;
    logAction: (interactionType: MeetingMessageActionType, propertyNames?: string[]) => void;
    groupId?: string;
}

export default observer(function MeetingCancellationInfo(props: MeetingCancellationInfoProperties) {
    return props.groupId || props.item.IsOrganizer ? null : (
        <div className={styles.container}>
            <MeetingCancellationAction item={props.item} logAction={props.logAction} />
        </div>
    );
});
